import Hellosign from 'hellosign-embedded';

export const hellosignClient = new Hellosign();
